/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connectRequests } from '../../../../../higherOrderComponents/requests';

export default connectRequests(state => {
  const token = state.token;
  return {
    patchSubscription: {
      method: 'PATCH',
      url: `/subscribers?token=${token}`
    }
  };
});
